import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  SubHeader,
  ImgSet,
  Ingress,
  Payoff,
  ImageBlock,
  PageWrapper,
} from '../components/Utils'
import { colors } from '../variables'

import skateboard from '../img/photos/skateboard.jpg'
import dog from '../img/photos/dog.jpg'
import running from '../img/photos/running.jpg'
import baby from '../img/photos/baby.jpg'
import { UIStore } from '../stores/UIStore'
import { Container, Row, Col, Hidden } from 'react-grid-system'

import soran from '../img/photos/soran.jpg'

const Developers = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.white)
  })

  return (
    <>
      <LandingArea />
      <PageWrapper
        style={{
          backgroundColor: colors.white,
        }}
      >
        <Container>
          <Row style={{ marginTop: 60 }}>
            <Col xs={12} sm={6}>
              <StyledPayoff>
                Vi deltar aktivt i din utvecklarresa och lägger planer efter
                dina prioriteringar. Flipperspel, tråkiga månadsmöten och
                obligatoriska konferenser finns inte på kartan på
                Utvecklarbolaget. Vi jobbar däremot tillsammans för att du efter
                3 år kommer kunna få ditt eget aktiebolag. Utvecklarbolaget står
                för kostnaden!
              </StyledPayoff>
            </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginTop: 80 }}>
            <Hidden xs>
              <Col sm={1} />
            </Hidden>
            <Col xs={12} sm={5}>
              <SubHeader style={{ color: colors.orange }}>
                Att jobba på Utvecklarbolaget
                <br />- inte för oss utan med oss
              </SubHeader>
              <Ingress>
                Du kommer få bra lön för ditt arbete. Du är stjärnan hos oss.
                Därför får du mer än Utvecklarbolaget i varje affär. Vi har inga
                onödiga utgifter som leksaker eller ett ballt kontor. Du slipper
                trista konferenser och meningslösa internmöten. Vi tror på att
                ha en harmonisk livssituation. Därför bistår vi bland annat med
                våra goda kontakter och referenser inom bank, försäkringar,
                boende. Från dag 1. Lätt är rätt.
              </Ingress>
            </Col>
            <Col xs={12} sm={6}>
              <SoranImg src={soran} alt="Soran Yilmaz" />
            </Col>
          </Row>
          <StyledRow>
            <Col sm={1} />
            <Col sm={4}>
              <SubHeader style={{ color: colors.orange }}>
                Ditt egna aktiebolag.
              </SubHeader>
              <Ingress>
                Du får efter 36 månader som anställd hos oss ett helt färdigt
                aktiebolag där du är ägare. Vårt skräddarsydda
                entreprenörsprogram Bolag 2.0 kommer med många inbyggda fördelar
                så du är väl förberedd. Utöver affärsmannaskap får du tillgång
                till samtliga kontakter Utvecklarbolaget har för redovisning,
                bank, revision och försäkringar. Vi erbjuder också möjligheten
                till vår BAAS (Business As A Service) där vi sköter allt
                administrativt åt dig så du kan fokusera på det som du verkligen
                brinner för- teknisk specialisering/expertis och
                mjukvaruutveckling.
                <br />
                Vi ger dig även en trygg start som entreprenör med din senaste
                kund som start i din egen kundportfölj. Dessutom fortsätter vi -
                om du vill - att använda vårt nätverk på Utvecklarbolaget för
                att hitta nästa spännande uppdrag åt dig. Men du bestämmer - du
                är chefen!
              </Ingress>
            </Col>
            <Col sm={1} />
            <Col sm={4}>
              <SubHeader style={{ color: colors.orange }}>
                Lätt är rätt - ett enkelt bonussystem
              </SubHeader>
              <Ingress>
                Eftersom vi gillar att det är enkelt tycker vi att det ska vara
                tydligt vad du får som anställd och därför är vårt bonussystem
                lätt att förstå. För varje hela månad du är anställd på uppdrag
                får du 1 poäng. När du har 36 poäng får du välja om du vill gå
                vägen med entreprenörsskap och få ditt egna aktiebolag eller en
                bonus som är en engångsersättning motsvarande samma belopp
                (2020: 115000 kr före skatt).
                <br />
                Friheten att välja är din. I de bästa av världar är det helt upp
                till dig och det här valet gör du: bra bonus eller börja banan
                som en stabil grund att stå på som entreprenör?
              </Ingress>
            </Col>
          </StyledRow>
        </Container>
      </PageWrapper>
    </>
  )
}

export const LandingArea = () => (
  <LandingHolder>
    <Container>
      <Row>
        <Col>
          <h1>Mer än lön - utveckling och entreprenörskap på riktigt</h1>
        </Col>
        <Hidden xs>
          <Col>
            <ImageBlock style={{ left: '10px' }}>
              <ImgSet img={skateboard} style={{ top: 0, left: 60 }} />
              <ImgSet img={dog} style={{ top: 145, left: 546 }} />
              <ImgSet img={baby} style={{ top: 463, left: -5 }} />
              <ImgSet img={running} style={{ top: 463, left: 241 }} />
            </ImageBlock>
          </Col>
        </Hidden>
      </Row>
    </Container>
  </LandingHolder>
)

const LandingHolder = styled.div`
  padding-top: 140px;
  box-sizing: border-box;
`

const StyledPayoff = styled(Payoff)`
  @media (min-width: 769px) {
    margin-left: 60px;
  }
`

const StyledRow = styled(Row)`
  @media (min-width: 769px) {
    margin-top: 150px;
    margin-bottom: 140px;
  }
`

const SoranImg = styled.img`
  max-width: 100%;

  @media (min-width: 769px) {
    margin-left: 60px;
  }
`

export default Developers
